<div class="spinner-holder">
    <div class="spinner"></div>
</div>
